import { Guid } from 'guid-typescript';
import React from 'react';
import ListDropdown from '../../List/ListDropdown';
import ListQestIds from './ListQestIds';
import ListType from './ListType';

export interface IQestlabListDropdownProps {
  maxResults?: number;
  value?: any;
  defaultValue?: any;
  worksheetId?: any;
  onChange?: (_: any) => void;
  placeholder?: string;
  listType?: ListType;
  queryParams?: any;
}

//default query paramaters for common lists.
const defaultQueryParams = {
  [ListType.Weather]: {
    qestId: ListQestIds.weather,
    labelField: 'Weather',
  },
  [ListType.AdditiveMaterialTypeName]: {
    qestId: ListQestIds.additiveMaterialType,
    labelField: 'ProductTypeName',
  },
  [ListType.TimeSequence]: {
    qestId: ListQestIds.timeSequence,
    labelField: 'TimeSequenceCode',
  },
};

let QestlabListDropdown: React.FC<IQestlabListDropdownProps> = ({
  maxResults = 20,
  value = null,
  defaultValue = null,
  worksheetId: availableForTestId,
  onChange,
  placeholder = 'Select...',
  listType,
  queryParams = {},
  ...otherProps
}) => {
  const qlListOnChange = (evt: any) => {
    if (evt.data.value === null) {
      evt.data.value = null;
    } else {
      // Selected list items have a valid Guid for Id
      if (Guid.isGuid(evt.data.value.value)) {
        evt.data.value = { Id: evt.data.value.value, Label: evt.data.value.label };
      } else {
        // Assume free entry item, set Id to empty guid
        evt.data.value = { Id: Guid.createEmpty().toString(), Label: evt.data.value.label };
      }
    }

    if (onChange) onChange(evt);
  };
  const resultQueryParams = {
    ...(!!listType ? defaultQueryParams[listType] : {}),
    ...{ queryParams },
  };
  return (
    <ListDropdown
      {...otherProps}
      endpoint="list.qestlabList"
      initEndpoint="list.qestlabList.options"
      placeholder={placeholder}
      onChange={qlListOnChange}
      value={value && (value.Label || value.Id) ? { value: value.Id, label: value.Label } : null}
      queryParams={{ ...resultQueryParams, availableForTestId, limit: maxResults }}
      defaultValue={{ value: defaultValue && defaultValue.Id, label: defaultValue && defaultValue.Name }}
      maxResults={maxResults}
    />
  );
};

export { QestlabListDropdown };
export default QestlabListDropdown;
